import "./datatable.scss";
import {
  studentattendanceColumns,
  fetchStudentattendanceRows,
} from "../../datatablesource";
import {
  DataGrid,
  GridToolbar,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../loader/Loader";

// Import Material Icons (assuming you have @mui/icons-material installed)
import RefreshIcon from "@mui/icons-material/Refresh";

const StudentAttendanceDataTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { slugs } = useSlug();
  const [rowCount, setRowCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [filters, setFilters] = useState({
    center_id: localStorage.getItem("center_id") || "1",
    class_id: "",
    student_id: "",
    date_from: "",
    date_to: "",
  });
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  const [isClassesLoading, setIsClassesLoading] = useState(false);
  const [isStudentsLoading, setIsStudentsLoading] = useState(false);

  useEffect(() => {
    const fetchClasses = async () => {
      setIsClassesLoading(true);
      try {
        const res = await fetch(
          `${serverUrl}/result_dashboard/class_dropdown?centerId=${filters.center_id}`,
        );
        const data = await res.json();
        if (data.code) {
          setClasses(data.data || []);
        } else {
          throw new Error("Failed to fetch classes");
        }
      } catch (error) {
        console.error("Error fetching classes:", error);
        toast.error("Failed to load class options.");
      } finally {
        setIsClassesLoading(false);
      }
    };

    fetchClasses();
  }, [filters.center_id]);

  useEffect(() => {
    const fetchStudents = async () => {
      if (!filters.class_id) {
        setStudents([]);
        return;
      }
      setIsStudentsLoading(true);
      try {
        const studentResponse = await fetch(
          `${serverUrl}/result_dashboard/student_dropdown?centerId=${filters.center_id}&classId=${filters.class_id}`,
        );
        const studentData = await studentResponse.json();
        if (studentData.code) {
          setStudents(studentData.data || []);
        } else {
          throw new Error("Failed to fetch students");
        }
      } catch (error) {
        console.error("Error fetching students:", error);
        toast.error("Failed to load student options.");
      } finally {
        setIsStudentsLoading(false);
      }
    };

    fetchStudents();
  }, [filters.center_id, filters.class_id]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        const rows = await fetchStudentattendanceRows({
          ...filters,
          page: page + 1,
          limit: pageSize,
        });
        setData(rows.data || []);
        setRowCount(rows.pagination?.total_records || 0);
      } catch (error) {
        console.error("Error fetching attendance data:", error);
        toast.error("Failed to load attendance data.");
      }
      setLoading(false);
    };
    getData();
  }, [page, pageSize, filters]);

  const handleDelete = (id) => {
    fetch(`${serverUrl}/del_student_attendance/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to delete student attendance");
        }
        setData(data.filter((item) => item.id !== id));
        toast.success("Student Attendance deleted successfully!");
      })
      .catch((error) => {
        console.error("Delete error:", error);
        toast.error("Failed to delete student attendance. Please try again.");
      });
  };

  const saveStudentData = (params) => {
    localStorage.setItem("student_id", params.row.student_id);
    localStorage.setItem("student_name", params.row.student_name);
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
    if (name === "class_id") {
      setFilters((prev) => ({ ...prev, student_id: "" }));
    }
    setPage(0);
  };

  const handleDateChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
    setPage(0);
  };

  const handleResetFilters = () => {
    setFilters({
      center_id: localStorage.getItem("center_id") || "1",
      class_id: "",
      student_id: "",
      date_from: "",
      date_to: "",
    });
    setPage(0);
  };

  const viewLinkString = "Studentattendance-Single";
  const editLinkString = "Studentattendance-Edit";
  const newLinkString = "Studentattendance-New";
  const AbsentformLinkString = "Absentform-Listing";
  const LateformLinkString = "Lateform-Listing";
  const LeaveformLinkString = "Leaveform-Listing";
  const HalfleaveformLinkString = "Halfleaveform-Listing";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 300,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/student-attendance/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/student-attendance/update-student-attendance/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}
            {params.row.subject_name === "General" && (
              <>
                {slugs &&
                  slugs.includes(AbsentformLinkString) &&
                  params.row.status === 0 && (
                    <Link
                      to={`/student-attendance/absent-form`}
                      style={{ textDecoration: "none" }}
                      onClick={() => saveStudentData(params)}
                    >
                      <div className="absButton">Absent Form</div>
                    </Link>
                  )}
                {slugs &&
                  slugs.includes(LateformLinkString) &&
                  params.row.status === 2 && (
                    <Link
                      to={`/student-attendance/late-form`}
                      style={{ textDecoration: "none" }}
                      onClick={() => saveStudentData(params)}
                    >
                      <div className="lateButton">Late Form</div>
                    </Link>
                  )}
                {slugs &&
                  slugs.includes(LeaveformLinkString) &&
                  params.row.status === 3 && (
                    <Link
                      to={`/student-attendance/leave-Form`}
                      style={{ textDecoration: "none" }}
                      onClick={() => saveStudentData(params)}
                    >
                      <div className="leaveButton">Leave Form</div>
                    </Link>
                  )}
                {slugs &&
                  slugs.includes(HalfleaveformLinkString) &&
                  params.row.status === 4 && (
                    <Link
                      to={`/student-attendance/half-leave-form`}
                      style={{ textDecoration: "none" }}
                      onClick={() => saveStudentData(params)}
                    >
                      <div className="halfleaveButton">Half Leave Form</div>
                    </Link>
                  )}
              </>
            )}
            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <div className="datatable p-4">
      <div className="flex flex-col gap-4 mb-5">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3">
          <div className="text-gray-700 text-2xl font-semibold">
            Student Attendance
          </div>
          <div className="flex gap-3">
            <button
              onClick={handleResetFilters}
              className="commonButton w-full sm:w-auto flex items-center justify-center"
              title="Reset Filters"
            >
              <RefreshIcon /> &nbsp; Reset Filters
            </button>
            {slugs && slugs.includes(newLinkString) && (
              <Link
                to="/student-attendance/new"
                className="commonButton w-full sm:w-auto"
              >
                Add New
              </Link>
            )}
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 flex-wrap !mb-5">
          <div className="flex-1 min-w-[150px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Class
            </label>
            <select
              name="class_id"
              value={filters.class_id}
              onChange={handleFilterChange}
              disabled={isClassesLoading}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">All Classes</option>
              {isClassesLoading ? (
                <option value="">Loading...</option>
              ) : (
                classes.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.name}
                  </option>
                ))
              )}
            </select>
          </div>
          <div className="flex-1 min-w-[150px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Student
            </label>
            <select
              name="student_id"
              value={filters.student_id}
              onChange={handleFilterChange}
              disabled={!filters.class_id || isStudentsLoading}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
            >
              <option value="">
                {!filters.class_id
                  ? "Select Class First"
                  : isStudentsLoading
                    ? "Loading..."
                    : "All Students"}
              </option>
              {!isStudentsLoading &&
                students.map((student) => (
                  <option key={student.id} value={student.id}>
                    {student.name}
                  </option>
                ))}
            </select>
          </div>
          <div className="flex-1 min-w-[150px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date From
            </label>
            <input
              type="date"
              name="date_from"
              value={filters.date_from}
              onChange={(e) => handleDateChange("date_from", e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div className="flex-1 min-w-[150px]">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Date To
            </label>
            <input
              type="date"
              name="date_to"
              value={filters.date_to}
              onChange={(e) => handleDateChange("date_to", e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>
      {loading ? (
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={studentattendanceColumns.concat(actionColumn)}
          page={page}
          pageSize={pageSize}
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
            setPage(0);
          }}
          pagination
          paginationMode="server"
          rowCount={rowCount}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          components={{
            Toolbar: GridToolbar,
          }}
          sortModel={[
            {
              field: "id",
              sort: "desc",
            },
          ]}
        />
      )}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default StudentAttendanceDataTable;
